import React from 'react';

export const LOVE_ICON = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="#0F1D27" stroke="#00D6AF" />
      <mask
        id="path-2-outside-1_157_1039"
        maskUnits="userSpaceOnUse"
        x="2.84619"
        y="4.38477"
        width="15"
        height="13"
        fill="black"
      >
        <rect fill="white" x="2.84619" y="4.38477" width="15" height="13" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.63259 5.38477H6.58127V6.92325L5.21378 6.92325V8.46174H3.84619V10.0002H5.21378V11.5387H6.58127V13.0772H7.94886V14.6157H9.31635V16.1542H10.6839V14.6157H12.0515V13.0772H13.419V11.5387H14.7866V10.0002H16.1541V8.46174H14.7866V6.92325L13.419 6.92325V5.38477H11.3677V6.92325H8.63259V5.38477Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.63259 5.38477H6.58127V6.92325L5.21378 6.92325V8.46174H3.84619V10.0002H5.21378V11.5387H6.58127V13.0772H7.94886V14.6157H9.31635V16.1542H10.6839V14.6157H12.0515V13.0772H13.419V11.5387H14.7866V10.0002H16.1541V8.46174H14.7866V6.92325L13.419 6.92325V5.38477H11.3677V6.92325H8.63259V5.38477Z"
        fill="url(#paint0_linear_157_1039)"
      />
      <path
        d="M6.58127 5.38477V4.38477H5.58127V5.38477H6.58127ZM8.63259 5.38477H9.63259V4.38477H8.63259V5.38477ZM6.58127 6.92325L6.58127 7.92325L7.58127 7.92325V6.92325H6.58127ZM5.21378 6.92325L5.21378 5.92325L4.21378 5.92325V6.92325H5.21378ZM5.21378 8.46174V9.46174H6.21378V8.46174H5.21378ZM3.84619 8.46174V7.46174H2.84619V8.46174H3.84619ZM3.84619 10.0002H2.84619V11.0002H3.84619V10.0002ZM5.21378 10.0002H6.21378V9.00023H5.21378V10.0002ZM5.21378 11.5387H4.21378V12.5387H5.21378V11.5387ZM6.58127 11.5387H7.58127V10.5387H6.58127V11.5387ZM6.58127 13.0772H5.58127V14.0772H6.58127V13.0772ZM7.94886 13.0772H8.94886V12.0772H7.94886V13.0772ZM7.94886 14.6157H6.94886V15.6157H7.94886V14.6157ZM9.31635 14.6157H10.3163V13.6157H9.31635V14.6157ZM9.31635 16.1542H8.31635V17.1542H9.31635V16.1542ZM10.6839 16.1542V17.1542H11.6839V16.1542H10.6839ZM10.6839 14.6157V13.6157H9.68389V14.6157H10.6839ZM12.0515 14.6157V15.6157H13.0515V14.6157H12.0515ZM12.0515 13.0772V12.0772H11.0515V13.0772H12.0515ZM13.419 13.0772V14.0772H14.419V13.0772H13.419ZM13.419 11.5387V10.5387H12.419V11.5387H13.419ZM14.7866 11.5387V12.5387H15.7866V11.5387H14.7866ZM14.7866 10.0002V9.00023H13.7866V10.0002H14.7866ZM16.1541 10.0002V11.0002H17.1541V10.0002H16.1541ZM16.1541 8.46174H17.1541V7.46174H16.1541V8.46174ZM14.7866 8.46174H13.7866V9.46174H14.7866V8.46174ZM14.7866 6.92325H15.7866V5.92325L14.7866 5.92325V6.92325ZM13.419 6.92325H12.419V7.92325L13.419 7.92325V6.92325ZM13.419 5.38477H14.419V4.38477H13.419V5.38477ZM11.3677 5.38477V4.38477H10.3677V5.38477H11.3677ZM11.3677 6.92325V7.92325H12.3677V6.92325H11.3677ZM8.63259 6.92325H7.63259V7.92325H8.63259V6.92325ZM6.58127 6.38477H8.63259V4.38477H6.58127V6.38477ZM7.58127 6.92325V5.38477H5.58127V6.92325H7.58127ZM5.21378 7.92325H6.58127L6.58127 5.92325L5.21378 5.92325L5.21378 7.92325ZM6.21378 8.46174V6.92325H4.21378V8.46174H6.21378ZM3.84619 9.46174H5.21378V7.46174H3.84619V9.46174ZM4.84619 10.0002V8.46174H2.84619V10.0002H4.84619ZM5.21378 9.00023H3.84619V11.0002H5.21378V9.00023ZM6.21378 11.5387V10.0002H4.21378V11.5387H6.21378ZM6.58127 10.5387H5.21378V12.5387H6.58127V10.5387ZM7.58127 13.0772V11.5387H5.58127V13.0772H7.58127ZM7.94886 12.0772H6.58127V14.0772H7.94886V12.0772ZM8.94886 14.6157V13.0772H6.94886V14.6157H8.94886ZM9.31635 13.6157H7.94886V15.6157H9.31635V13.6157ZM10.3163 16.1542V14.6157H8.31635V16.1542H10.3163ZM10.6839 15.1542H9.31635V17.1542H10.6839V15.1542ZM9.68389 14.6157V16.1542H11.6839V14.6157H9.68389ZM12.0515 13.6157H10.6839V15.6157H12.0515V13.6157ZM11.0515 13.0772V14.6157H13.0515V13.0772H11.0515ZM13.419 12.0772H12.0515V14.0772H13.419V12.0772ZM12.419 11.5387V13.0772H14.419V11.5387H12.419ZM14.7866 10.5387H13.419V12.5387H14.7866V10.5387ZM13.7866 10.0002V11.5387H15.7866V10.0002H13.7866ZM16.1541 9.00023H14.7866V11.0002H16.1541V9.00023ZM15.1541 8.46174V10.0002H17.1541V8.46174H15.1541ZM14.7866 9.46174H16.1541V7.46174H14.7866V9.46174ZM13.7866 6.92325V8.46174H15.7866V6.92325H13.7866ZM13.419 7.92325H14.7866V5.92325L13.419 5.92325V7.92325ZM12.419 5.38477V6.92325H14.419V5.38477H12.419ZM11.3677 6.38477H13.419V4.38477H11.3677V6.38477ZM12.3677 6.92325V5.38477H10.3677V6.92325H12.3677ZM8.63259 7.92325H11.3677V5.92325H8.63259V7.92325ZM7.63259 5.38477V6.92325H9.63259V5.38477H7.63259Z"
        fill="#00FFD1"
        mask="url(#path-2-outside-1_157_1039)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_157_1039"
          x1="10.0001"
          y1="5.38477"
          x2="10.0001"
          y2="16.1542"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A076FF" />
          <stop offset="1" stopColor="#A076FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const RightArrowVE = ({ stroke }: { stroke?: string }) => {
  return (
    <svg
      width="17"
      height="11"
      viewBox="0 0 17 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.19629e-07 5.2L15.7714 5.2M11.2 10L16 5.2L11.2 0.399998"
        stroke={stroke || '#00FFD1'}
      />
    </svg>
  );
};

export const VE_ICON = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.5" fill="#0F1D27" stroke="#00D6AF" />
      <rect
        x="4.375"
        y="7.37646"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="4.375"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="7.98077"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="7.37646"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="10.8799"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="11.458"
        y="12.6309"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="13.2094"
        y="5.625"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="13.2094"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="13.2094"
        y="12.6309"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="4.375"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="5.40524"
        y="10.7764"
        width="3.34822"
        height="1.80289"
        fill="#00FFD1"
      />
      <rect
        x="6.17786"
        y="12.5791"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="7.98083"
        y="9.12793"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
      <rect
        x="7.98083"
        y="7.37646"
        width="1.75138"
        height="1.75138"
        fill="#00FFD1"
      />
    </svg>
  );
};

export const RewardCheck = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 3.5L3.66667 6L9 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const VETip = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1104_2248)">
        <path
          d="M0 7C0.00218939 5.14416 0.74039 3.36495 2.05267 2.05267C3.36495 0.74039 5.14416 0.00218939 7 0C8.85584 0.00218939 10.635 0.74039 11.9473 2.05267C13.2596 3.36495 13.9978 5.14416 14 7C13.998 8.8559 13.2598 10.6352 11.9475 11.9475C10.6352 13.2598 8.8559 13.998 7 14C5.14416 13.9978 3.36495 13.2596 2.05267 11.9473C0.74039 10.635 0.00218939 8.85584 0 7H0ZM1.27273 7C1.27458 8.5184 1.87858 9.97408 2.95225 11.0477C4.02592 12.1214 5.4816 12.7254 7 12.7273C8.5184 12.7254 9.97408 12.1214 11.0477 11.0477C12.1214 9.97408 12.7254 8.5184 12.7273 7C12.7253 5.48165 12.1212 4.02607 11.0476 2.95244C9.97393 1.8788 8.51835 1.27475 7 1.27273C5.48165 1.27475 4.02607 1.8788 2.95244 2.95244C1.8788 4.02607 1.27475 5.48165 1.27273 7ZM6.04545 10.1634C6.04545 9.9102 6.14602 9.66741 6.32503 9.4884C6.50405 9.30939 6.74684 9.20882 7 9.20882C7.25316 9.20882 7.49595 9.30939 7.67497 9.4884C7.85398 9.66741 7.95455 9.9102 7.95455 10.1634C7.95455 10.4165 7.85398 10.6593 7.67497 10.8383C7.49595 11.0173 7.25316 11.1179 7 11.1179C6.74695 11.1179 6.50425 11.0174 6.32526 10.8386C6.14627 10.6597 6.04562 10.4171 6.04545 10.164V10.1634ZM6.36364 7.95709V3.04373H7.63636V7.95709H6.36364Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1104_2248">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const VEARROW = (props: any) => {
  return (
    <svg
      {...props}
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.592725 9.07808L8.95679 0.714013M3.9397 0.545655L9.07801 0.592795L9.12515 5.7311"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const DownArrowVE = () => {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.11372e-08 7.38265C-3.27892e-05 7.54503 0.0723861 7.70172 0.203402 7.82274L3.40758 10.781C3.70106 11.052 4.20422 11.0746 4.53142 10.8315C4.55284 10.8156 4.57321 10.7987 4.59242 10.781L7.79658 7.82274C8.09007 7.55179 8.06274 7.13509 7.73556 6.89203C7.58966 6.7836 7.40038 6.7236 7.20415 6.72358L5.75927 6.72357C5.48313 6.72357 5.25927 6.49971 5.25927 6.22357V0.997837C5.25927 0.446742 4.71866 0 4.05175 0C3.38485 0 2.84423 0.446742 2.84423 0.997825V6.22356C2.84423 6.49971 2.62037 6.72356 2.34423 6.72356H0.795846C0.360713 6.72356 0.00711989 7.01278 0.000104992 7.37175L1.11372e-08 7.38265Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UpArrowVE = () => {
  return (
    <svg
      width="8"
      height="11"
      viewBox="0 0 8 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="transform rotate-180"
    >
      <path
        d="M1.11372e-08 7.38265C-3.27892e-05 7.54503 0.0723861 7.70172 0.203402 7.82274L3.40758 10.781C3.70106 11.052 4.20422 11.0746 4.53142 10.8315C4.55284 10.8156 4.57321 10.7987 4.59242 10.781L7.79658 7.82274C8.09007 7.55179 8.06274 7.13509 7.73556 6.89203C7.58966 6.7836 7.40038 6.7236 7.20415 6.72358L5.75927 6.72357C5.48313 6.72357 5.25927 6.49971 5.25927 6.22357V0.997837C5.25927 0.446742 4.71866 0 4.05175 0C3.38485 0 2.84423 0.446742 2.84423 0.997825V6.22356C2.84423 6.49971 2.62037 6.72356 2.34423 6.72356H0.795846C0.360713 6.72356 0.00711989 7.01278 0.000104992 7.37175L1.11372e-08 7.38265Z"
        fill="currentColor"
      />
    </svg>
  );
};
